import organizationService from "@/services/bytepro/organization.service";
// import moment from 'moment';

export const organizationApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    get({ commit }) {
      return organizationService.get().then(
        (resp) => {
          commit("dummyConsole", "get - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummyConsole", "get - error");
          return Promise.reject(error);
        }
      );
    },

    getRelatedOrganizationList({ commit }) {
      return organizationService.getRelatedOrganizationList().then(
        (resp) => {
          commit("dummyConsole", "getRelatedOrganizationList - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummyConsole", "getRelatedOrganizationList - error");
          return Promise.reject(error);
        }
      );
    },

    getOne({ commit }, organizationId) {
      return organizationService.getOne(organizationId).then(
        (resp) => {
          commit("dummyConsole", "getOne - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummyConsole", "getOne - error");
          return Promise.reject(error);
        }
      );
    },

    getOrganizationDetail({ commit }, organizationId) {
      return organizationService.getOrganizationDetail(organizationId).then(
        (resp) => {
          commit("dummyConsole", "getOrganizationDetail - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummyConsole", "getOrganizationDetail - error");
          return Promise.reject(error);
        }
      );
    },

    getOrganizationByNMLS({ commit }, nmls) {
      return organizationService.getOrganizationByNMLS(nmls).then(
        (resp) => {
          commit("dummyConsole", "getOrganizationByNMLS - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummyConsole", "getOrganizationByNMLS - error");
          return Promise.reject(error);
        }
      );
    },

    getChildOrganizations({ commit }) {
      return organizationService.getChildOrganizations().then(
        (resp) => {
          commit("dummyConsole", "getChildOrganizations - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummyConsole", "getChildOrganizations - error");
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {
    dummyConsole(state, obj) {
      console.log(obj);
    },
  },
};
